export default __webpack_public_path__ + "static/media/star-outline.0a063403.svg";